// extracted by mini-css-extract-plugin
export default {"CategoriesForm":"CategoriesForm_CategoriesForm__1CHov"};